"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeerDescriptorStoreManager = exports.MAX_NODE_COUNT = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const any_1 = require("../../generated/google/protobuf/any");
const parsePeerDescriptor = (dataEntries) => {
    return dataEntries.filter((entry) => !entry.deleted).map((entry) => any_1.Any.unpack(entry.data, dht_1.PeerDescriptor));
};
const logger = new utils_1.Logger(module);
exports.MAX_NODE_COUNT = 8;
/**
 * For each key there is usually 0-MAX_NODE_COUNT PeerDescriptors stored in the DHT. If there are fewer node,
 * the peer descriptor of the local node is stored to the DHT.
 */
class PeerDescriptorStoreManager {
    abortController;
    options;
    isLocalNodeStored_ = false;
    constructor(options) {
        this.options = options;
        this.abortController = new AbortController();
    }
    async fetchNodes() {
        logger.trace('Fetch data', { key: this.options.key });
        try {
            const result = await this.options.fetchDataFromDht(this.options.key);
            return parsePeerDescriptor(result);
        }
        catch {
            return [];
        }
    }
    async storeAndKeepLocalNode() {
        if (this.abortController.signal.aborted) {
            return;
        }
        // eslint-disable-next-line no-underscore-dangle
        this.isLocalNodeStored_ = true;
        await this.storeLocalNode();
        await this.keepLocalNode();
    }
    async storeLocalNode() {
        const localPeerDescriptor = this.options.localPeerDescriptor;
        const dataToStore = any_1.Any.pack(localPeerDescriptor, dht_1.PeerDescriptor);
        try {
            await this.options.storeDataToDht(this.options.key, dataToStore);
        }
        catch {
            logger.warn('Failed to store local node', { key: this.options.key });
        }
    }
    async keepLocalNode() {
        await (0, utils_1.scheduleAtInterval)(async () => {
            logger.trace('Attempting to keep local node', { key: this.options.key });
            try {
                const discovered = await this.fetchNodes();
                if (discovered.length < exports.MAX_NODE_COUNT
                    || discovered.some((peerDescriptor) => (0, dht_1.areEqualPeerDescriptors)(peerDescriptor, this.options.localPeerDescriptor))) {
                    await this.storeLocalNode();
                }
            }
            catch {
                logger.debug('Failed to keep local node', { key: this.options.key });
            }
        }, this.options.storeInterval ?? 60000, false, this.abortController.signal);
    }
    isLocalNodeStored() {
        // eslint-disable-next-line no-underscore-dangle
        return this.isLocalNodeStored_;
    }
    async destroy() {
        this.abortController.abort();
        await this.options.deleteDataFromDht(this.options.key, false);
    }
}
exports.PeerDescriptorStoreManager = PeerDescriptorStoreManager;
//# sourceMappingURL=PeerDescriptorStoreManager.js.map